import React from "react";
import * as utils from "common/utils";

const FarmGHG = ({ budget }) => {
    const { currentResults } = budget;
    if (!currentResults) return null;

    return (
        <div className="Table Table-Compressed">
            <table>
                <thead>
                    <tr>
                        <th data-width="25">Methane GHG emissions</th>
                        <th data-width="25">N2O GHG emissions</th>
                        <th data-width="25">CO2 GHG emissions</th>
                        <th data-width="25">Total GHG emissions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>
                            {utils.round((currentResults.ghgResults.methaneEmissionsTotal * currentResults.ghgResults.reportingArea) / 1000, 1)} <small>CO2-e tonnes/yr</small>
                        </td>
                        <td>
                            {utils.round((currentResults.ghgResults.n2OEmissionsTotal * currentResults.ghgResults.reportingArea) / 1000, 1)} <small>CO2-e tonnes/yr</small>
                        </td>
                        <td>
                            {utils.round((currentResults.ghgResults.cO2EmissionsTotal * currentResults.ghgResults.reportingArea) / 1000, 1)} <small>CO2-e tonnes/yr</small>
                        </td>
                        <td>
                            {utils.round((currentResults.ghgResults.total * currentResults.ghgResults.reportingArea) / 1000, 1)} <small>CO2-e tonnes/yr</small>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};

export default FarmGHG;
